// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Account } from './account';
import { ItemDetail } from './item-detail';
import { JoDetail } from './jo-detail';
import { ManufacturerProductTypeConfig } from './manufacturer-product-type-config';
import { PoDetailCancel } from './po-detail-cancel';
import { PoDetailType } from './po-detail-type';
import { PoHeader } from './po-header';
import { PoNote } from './po-note';
import { PoTrx } from './po-trx';
import { Product } from './product';

/// <code-import> Place custom imports between <code-import> tags
import _ from "lodash";
import { EntityPropertyAnnotation, EntityTypeAnnotation } from "../entity-type-annotation";
import { ItemDetailStatusEnum } from "./enums";
import { DateFns } from "@/shared/date-fns";
/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class PoDetail extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  // Note that we are using a not negative validator here - because Po mods can remove qty from an order detail leaving it with 0
  // and we need the hist trail for this.
  static getEntityTypeAnnotation(): EntityTypeAnnotation {
    const propAnnotations = [
      new EntityPropertyAnnotation("orderQty", {
        validators: [BaseEntity.notNegativeValidator],
      }),
    ];

    return new EntityTypeAnnotation({
      validators: [],
      propertyAnnotations: propAnnotations,
    });
  }

  // conceptual Note interface
  getHeader() {
    return this.poHeader;
  }

  getNotes() {
    return this.poNotes;
  }

  // next 3 all assume itemDetails have been fetched

  // An ItemDetail row only comes into existence once the unit physically
  // arrived, so every row counts as received no matter what happened to it
  // afterwards. Filtering on status here used to hide damaged (99), special
  // (60), missing (93) and migrated-unknown (91) units from Rcvd. The server
  // already uses this definition - UpdatePoStatusFromDetails completes a line
  // on PoDetailCancels.Sum(qty) + ItemDetails.Count() == OrderQty.
  getReceivedQty() {
    return this.itemDetails ? this.itemDetails.length : 0;
  }

  getShippedQty() {
    return this.itemDetails && this.itemDetails.filter((itd) => itd.itemDetailStatusId === ItemDetailStatusEnum.Shipped).length;
  }

  getDamagedQty() {
    return this.itemDetails && this.itemDetails.filter((itd) => itd.itemDetailStatusId === ItemDetailStatusEnum.DamagedOrOther).length;
  }

  // assumes poDetailCancels have been fetched
  getCanceledQty() {
    return this.poDetailCancels && _.sum(this.poDetailCancels.map((podc) => podc.qty));
  }

  // next 3 all assume itemDetails and poDetailCancels have been fetched

  // Damage is not a cancellation - the manufacturer still delivered the unit.
  // getReceivedQty already accounts for it, so subtracting it here as well
  // would count it twice.
  getUncanceledQty() {
    return this.orderQty - this.getCanceledQty();
  }

  getRemainingQty() {
    return this.getUncanceledQty() - (this.getReceivedQty() + this.heldQty);
  }

  // Damaged units arrived but will never ship from this line - marking one
  // damaged creates a replacement PoDetail - so they come out here.
  getRemainingUnshippedQty() {
    return this.getUncanceledQty() - (this.getShippedQty() + this.getDamagedQty());
  }

  // Jay: revise this if necessary
  // Jeff: I don't think that this is needed anymore.
  // get calcExpectedReceiveDate() {
  // const rq = this.getRemainingQty();
  // if (rq == 0) return null;
  //   if (!this.expectedReceiveDate) {
  //     return this.poHeader?.origExpectedReceiveDate;
  //   } else {
  //     return this.expectedReceiveDate;
  //   }
  // }
  /// </code>

  // Generated code. Do not place code below this line.
  /** Int32 key */
  id!: number;
  /** Int32 FK account */
  accountId?: number;
  /** DateTimeOffset */
  crtnTs?: Date;
  /** DateTime */
  expectedReceiveDate?: Date;
  /** DateTime */
  expectedShipDate?: Date;
  /** DateTimeOffset */
  expectedShipDateModTs?: Date;
  /** Int32 */
  heldQty!: number;
  /** Int32 FK joDetail */
  joDetailId?: number;
  /** Int32 FK manufacturerProductTypeConfig */
  manufacturerProductTypeConfigId?: number;
  /** DateTimeOffset */
  modTs?: Date;
  /** Int32 */
  orderQty!: number;
  /** Int32 FK origProduct */
  origProductId!: number;
  /** String(10) FK poDetailType */
  poDetailTypeId!: string;
  /** Int32 FK poHeader */
  poHeaderId?: number;
  /** Int32 FK poTrx */
  poTrxId?: number;
  /** Int32 FK product */
  productId!: number;
  /** Binary */
  rowVersion!: any;
  /** FK accountId */
  account!: Account;
  /** Inv FK poDetailId */
  itemDetails!: ItemDetail[];
  /** FK joDetailId */
  joDetail!: JoDetail;
  /** FK manufacturerProductTypeConfigId */
  manufacturerProductTypeConfig!: ManufacturerProductTypeConfig;
  /** FK origProductId */
  origProduct!: Product;
  /** Inv FK poDetailId */
  poDetailCancels!: PoDetailCancel[];
  /** FK poDetailTypeId */
  poDetailType!: PoDetailType;
  /** FK poHeaderId */
  poHeader!: PoHeader;
  /** Inv FK poDetailId */
  poNotes!: PoNote[];
  /** FK poTrxId */
  poTrx!: PoTrx;
  /** FK productId */
  product!: Product;
}

